import MedicalExpenseInput from './MedicalExpenseInput'

export default MedicalExpenseInput
